export interface ScrubbableBody {
  ssn?: string;
}

export interface ScrubbableHeader {
  Authorization?: string;
}

export interface ScrubbableConfig {
  data?: ScrubbableBody;
  headers?: ScrubbableHeader;
}

export interface ScrubbableErrorObject  {
  config?: ScrubbableConfig;
  response?: {
    config?: ScrubbableConfig;
  };
}

export const REDACTED = "<REDACTED>";

export const scrubPidAndAuthHeaders = <T extends ScrubbableErrorObject>(jsonAttributes: T): T => {
  let didScrub = false;
  const ret = {...jsonAttributes};

  if (ret.config !== undefined) {
    ret.config = scrubConfig(ret.config);
    didScrub = ret.config !== jsonAttributes.config;
  }

  if (ret.response !== undefined && ret.response.config !== undefined) {
    ret.response = {
      ...ret.response,
      config: scrubConfig(ret.response.config)
    };
    didScrub = didScrub || ret.response.config !== jsonAttributes.response.config;
  }

  if (didScrub) return ret;

  return jsonAttributes;
};

const scrubConfig = (scrubbableConfig: ScrubbableConfig) => {
  let didScrub = false;
  const ret = {...scrubbableConfig};

  // look for a 'data' attribute which would contain a POST body:
  if (scrubbableConfig.data !== undefined) {
    ret.data = redact(ret.data, "ssn");
    didScrub = ret.data !== scrubbableConfig.data;
  }

  if (scrubbableConfig.headers !== undefined) {
    ret.headers = redact(ret.headers, "Authorization");
    didScrub = didScrub || ret.headers !== scrubbableConfig.headers;
  }

  if (didScrub) return ret;

  return scrubbableConfig;
};

const redact = <T extends object>(t: T, ...props: (keyof T)[]) => {
  let didRedact = false;
  let t2 = t;
  if (typeof t === "string" || t instanceof String) {
    try {
      t2 = JSON.parse(t as unknown as string);
    } catch {
      t2 = {} as T;
    }
  }

  const redactedT = {...t2};

  props.forEach(prop => {
    if (redactedT[prop] !== undefined) {
      redactedT[prop] = REDACTED as any;
      didRedact = true;
    }
  });

  if (didRedact) return redactedT;

  return t;
};
